import $ from "jquery";
import _ from "underscore";
import moment from "moment-timezone";
import XolaBackboneSDK from "../Xola";
import { Config } from "../application/Config";
import { UpcomingEvents } from "./UpcomingEvents";

export const AvailableEvents = UpcomingEvents.extend({
    urlRoot: '/availability',

    initialize(models = null, options = {}) {
        UpcomingEvents.prototype.initialize.apply(this, arguments);

        this.events = options.events;
    },

    fetchDaysEvents(data) {
        var now = moment.tz(Config.timezone);
        var startTime = now.clone();
        var endTime;
        if (Config.display.get("config").events.showTomorrowsEvents) {
            endTime = now.clone().add(1, "day");
        }
        else {
            endTime = now.clone();
        }


        if (this.events) {
            return this.events.fetchDaysEvents(data).then(() => {

                _.extend(data.data, {
                    start: startTime.format('YYYY-MM-DD'),
                    end: endTime.format('YYYY-MM-DD')
                });
                this.fetch(data);

            });
        }
        else {
            _.extend(data.data, {
                start: startTime.format('YYYY-MM-DD'),
                end: endTime.format('YYYY-MM-DD')
            });

            return this.fetch(data);
        }
    },

    parse(response) {
        var events = [];

        var now = moment.tz(Config.timezone);
        var experienceCollection = XolaBackboneSDK.CollectionPool.getCollection(XolaBackboneSDK.Collection.Experiences);
        $.each(response, (experienceId, dates) => {
            var experience = experienceCollection.get(experienceId);
            if (!experience) {
                return;
            }

            $.each(dates, (date, times) => {
                $.each(times, (time, open) => {
                    var eventId = date + ':' + time + '-' + experienceId;
                    var start = moment.tz(date + ('0000' + time).slice(-4), 'YYYY-MM-DDHHmm', Config.timezone);

                    var event = {
                        id: eventId,
                        open: open,
                        max: experience.get("group") ? experience.get("group").outingMax : null,
                        start: start,
                        experience: {
                            id: experienceId
                        },
                        guides: []
                    };

                    if (this.events) {
                        var existingEvent = this.events.findByExperienceAndTime({id: experienceId}, date, time);
                        if (existingEvent) {
                            event.guides = existingEvent.get("guides");
                            event.quantity = existingEvent.get("quantity");
                        }
                    }

                    if (start.format('HHmm') != "0000" && this.getHideTime(event).isAfter(now)) {
                        if (Config.display.get("config").events.capacity == "available") {
                            if (open > 0) {
                                events.push(event);
                            }
                        }
                        else {
                            events.push(event);
                        }
                    }
                });
            });
        });

        return events;
    },
});



// WEBPACK FOOTER //
// ./src/js/collections/AvailableEvents.js